module.exports = __webpack_public_path__ + "static/media/RethinktheInternetBookCover.1a6173a0.jpg";